var app = angular.module("leonardo");

var ContactTypeListFilters = function(
  $scope,
  $controller,
  SectorRestService,
) {

  $controller('FiltersBaseController', {$scope: $scope});

  $scope.filters_options = [
    {
      id: 'sector',
      name: 'Sector',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select sector',
      condition: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
      service: SectorRestService,
      conflicts: ['category']
    },
    {
      id: 'contact_type_name',
      name: 'Contact Type Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Name contains',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('ContactTypeListFilters', [
  '$scope',
  '$controller',
  'SectorRestService',
  ContactTypeListFilters
]);
